import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import QuoteContainer from "~/Containers/QuoteContainer";
import QuoteBox from "~/Components/Global/QuoteBox";
import { useUser } from "@dreamchimney/user-context";
import CommentsContainer from "~/Containers/CommentsContainer";

const QuotePage = ({ match }) => {
  const { state: userState, dispatch } = useUser();
  const { date } = match.params;

  if (!userState.loaded) {
    return null;
  }
  const isChim = userState && userState.loggedin && userState.isChim;

  return (
    <div className="home-page-component">
      <Helmet>
        <title>Quote of the Day | {date} | Dream Chimney</title>
      </Helmet>

      <QuoteContainer
        date={date}
        render={({ loading, quote }) => {
          if (loading) return <div style={{ textAlign: "center", color: "white" }}> Loading ... </div>;
          return (
            <React.Fragment>
              <QuoteBox quote={quote} />

              <div className="go-previous">
                <Link to={`/`}>Most Recent</Link>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                <Link to={`/previous`}>Previous Quotes</Link>
              </div>

              <div>
                <div className="comments col-md-12">
                  <div className="comments-header">Comments</div>

                  {/* <div className="comments-list"></div> */}

                  <div className="comments-section">{quote && <CommentsContainer quote={quote} render={(items) => items} />}</div>
                </div>
              </div>
            </React.Fragment>
          );
        }}
      />
    </div>
  );
};

export default QuotePage;
